// Module
var code = `<iframe #cardNumberHostIframe
        [style.height]="height" style="width: 100%; display: block"
        [attr.tid]="tid + '-iframe'">
</iframe>
<span *ngIf="errorMessage" class="HOA-form-field-error" [attr.tid]="this.tid + '-error'">
    {{  errorMessage }}
</span>`;
// Exports
module.exports = code;